module.exports = __webpack_public_path__ + "static/img/bike.e2aff11.png";